(() => {
  const sliderSelector = '[data-product-card-mobile-slider]';
  const trackSelector = '[data-product-card-media-track]';

  function updateSteps(track, steps) {
    const slideWidth = Math.max(1, track.clientWidth);
    const activeIndex = Math.round(track.scrollLeft / slideWidth);

    steps.forEach((step, index) => {
      step.classList.toggle('active', index === activeIndex);
    });
  }

  function initProductCardSliders(root = document) {
    root.querySelectorAll(sliderSelector).forEach((media) => {
      if (media.dataset.mobileSliderInitialized === 'true') {
        return;
      }

      const track = media.querySelector(trackSelector);
      const steps = media.querySelectorAll('.slider-steps__item');

      if (!track || steps.length < 2) {
        return;
      }

      media.dataset.mobileSliderInitialized = 'true';

      let startX = 0;
      let hasDragged = false;
      let raf = null;

      const scheduleUpdate = () => {
        if (raf) return;

        raf = window.requestAnimationFrame(() => {
          updateSteps(track, steps);
          raf = null;
        });
      };

      track.addEventListener('scroll', scheduleUpdate, { passive: true });

      media.addEventListener('pointerdown', (event) => {
        startX = event.clientX;
        hasDragged = false;
      }, { passive: true });

      media.addEventListener('pointermove', (event) => {
        if (Math.abs(event.clientX - startX) > 8) {
          hasDragged = true;
        }
      }, { passive: true });

      media.addEventListener('click', (event) => {
        if (hasDragged) {
          event.preventDefault();
          event.stopImmediatePropagation();
          hasDragged = false;
        }
      }, true);

      updateSteps(track, steps);
    });
  }

  function observeDynamicProductCards() {
    if (!document.body || !document.querySelector(sliderSelector)) {
      return;
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            initProductCardSliders(node);
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initProductCardSliders();
    observeDynamicProductCards();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initProductCardSliders(event.target);
  });
})();